import { IRouterProvider } from "@contexts/router/types";
import { handleUseParams } from "@utils";
import {
  useLocation,
  useParams,
  Link,
  useNavigate,
  useBlocker,
} from "react-router-dom";
import { Prompt } from "./prompt";

export const ReactRouterProvider: IRouterProvider = {
  useHistory: () => {
    const navigate = useNavigate();

    return {
      push: navigate,
      replace: (path: string) => {
        navigate(path, { replace: true });
      },
      goBack: () => {
        navigate(-1);
      },
    };
  },
  useLocation,
  useParams: () => {
    const params = useParams();
    const { pathname } = useLocation();

    const paramsString = `/${Object.values(params).join("/")}`;
    return handleUseParams({
      ...params,
      resource:
        Object.keys(params).length === 0
          ? pathname.substring(1)
          : decodeURIComponent(pathname.substring(1)).replace(paramsString, ""),
    });
  },
  useBlocker: (shouldBlock: boolean | (() => boolean)) => {
    useBlocker(shouldBlock);
  },
  Prompt: Prompt,
  Link,
};
